// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Row from '@tcp/core/src/components/common/atoms/Row';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';
import { convertHtml } from '@tcp/core/src/components/features/CnC/LoyaltyBanner/util/utility';
import PreScreenCodeWrapper from './styles/PreScreenCode.style';
import ApplyCardPageLabels, { GLOBAL_LABELS } from '../../labels/ApplyCardPage.labels';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../utils/labels/labelUtilty';

export default class PrescreenCode extends React.PureComponent {
  static propTypes = {
    labels: PropTypes.shape({}).isRequired,
  };

  state = {
    showPreScreenCode: false,
  };

  globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, ApplyCardPageLabels);

  handleClick = (e) => {
    /* eslint-disable no-unused-expressions */
    e && e.preventDefault();
    this.setState({ showPreScreenCode: true });
  };

  render() {
    const { plccOfferPercentage } = this.props;
    const { accountDrawer } = this.globalLabels;
    const { showPreScreenCode } = this.state;
    const placeholderValue = '#plccOfferPercentage#';

    const plccDescription2 = getDynamicLabelValues(
      'dynamic.account_d.lbl_accountDrawer_myPlaceRewardsCC_benefits_description_para2'
    ).replace(placeholderValue, plccOfferPercentage);
    return (
      <PreScreenCodeWrapper>
        {
          <>
            <h2 className="benefit_heading">
              {renderLabel(
                accountDrawer?.lbl_accountDrawer_myPlaceRewardsCC_benefits_heading,
                'lbl_accountDrawer_myPlaceRewardsCC_benefits_heading'
              ) || ''}
            </h2>
            <BodyCopy className="benefit_description1">
              {getDynamicLabelValues(
                'dynamic.account_d.lbl_accountDrawer_myPlaceRewardsCC_benefits_description_para1'
              ) || ''}
            </BodyCopy>
            <BodyCopy className="benefit_description2">
              {convertHtml(plccDescription2) || ''}
            </BodyCopy>
            <BodyCopy className="benefit_description3">
              {getDynamicLabelValues(
                'dynamic.account_d.lbl_accountDrawer_myPlaceRewardsCC_benefits_description_para3'
              ) || ''}
            </BodyCopy>
          </>
        }
        {showPreScreenCode ? (
          <Row fullBleed>
            <Col
              className="contact_information_form"
              key="Prescreen_codelink"
              colSize={{ large: 6, medium: 4, small: 6 }}
            >
              <Field
                placeholder={getDynamicLabelValues(
                  'dynamic.global_d.lbl_PLCCForm_preScreenCodeOpt'
                )}
                name="preScreenCode"
                id="preScreenCode"
                maxLength={12}
                component={TextBox}
                dataLocator="Prescreen_codelink"
                className="field"
              />
            </Col>
          </Row>
        ) : null}
        <BodyCopy fontFamily="secondary">
          {getDynamicLabelValues('dynamic.global_d.lbl_PLCCForm_preScreenCodeText')}

          {!showPreScreenCode ? (
            <Anchor href="#" noLink onClick={this.handleClick} className="click-here-link">
              {getDynamicLabelValues('dynamic.global_d.lbl_PLCCForm_clickHere')}
            </Anchor>
          ) : (
            <BodyCopy component="span" role="button" className="prescreen-code">
              {getDynamicLabelValues('dynamic.global_d.lbl_PLCCForm_enterHere')}
            </BodyCopy>
          )}
        </BodyCopy>
      </PreScreenCodeWrapper>
    );
  }
}

PrescreenCode.propTypes = {
  labels: PropTypes.shape({}).isRequired,
};
